import React from "react"

import { useFormikContext } from "formik"

import { TextAreaInput } from "~tailwindui/Form"

export type IssueCheckboxProps = {
  name: string
  label: string
  hint?: string
  descriptionRequired?: boolean
}

const IssueCheckbox: React.FC<IssueCheckboxProps> = ({
  name,
  label,
  hint = undefined,
  descriptionRequired = false,
}) => {
  const { values, setFieldValue }: any = useFormikContext()
  const active = !!values.sessionTechIssues.find(
    issue => issue.issueType === name
  )

  return (
    <>
      <div className="flex items-start">
        <div className="flex h-6 items-center">
          <input
            className="h-4 w-4 rounded border-gray-400 text-sky-600 focus:ring-sky-600"
            id={name}
            name={name}
            type="checkbox"
            value={name}
            checked={active}
            onChange={e => {
              if (e.currentTarget.checked) {
                setFieldValue("sessionTechIssues", [
                  ...values.sessionTechIssues,
                  { issueType: name },
                ])
              } else {
                setFieldValue(
                  "sessionTechIssues",
                  values.sessionTechIssues.filter(
                    issue => issue.issueType !== name
                  )
                )
              }
            }}
            aria-describedby={label}
          />
        </div>

        <div className="ml-3 text-lg leading-6 sm:text-sm">
          <label htmlFor={name} className="font-medium text-gray-900">
            <div>{label}</div>
            <span className="text-sm">{hint}</span>
          </label>
        </div>
      </div>

      {active && (
        <div className="ml-8">
          <TextAreaInput
            name={name}
            rows={2}
            label={`Please describe (${
              descriptionRequired ? "required" : "optional"
            }):`}
            onChange={e => {
              const issues = [...values.sessionTechIssues]
              issues.find(issue => issue.issueType === name).description =
                e.currentTarget.value
              setFieldValue("sessionTechIssues", issues)
            }}
          />
        </div>
      )}
    </>
  )
}

export default IssueCheckbox
